import React, { Component } from 'react';
import { Row, Col } from 'antd';
import StatusSymbol from "../../../components/StatusSymbol";
import SearchSelect from "../../../components/SearchSelect";
import { getCurrentUserEmail } from '../../auth/components/util'

class Header extends Component {

  render() {

    const { users, lineitem, viewState, handleUserChange, openSidesheet } = this.props
    const value = lineitem.getAssignedUser() === '' ? 'assignme' : lineitem.getAssignedUser()
    const currentUserEmail = getCurrentUserEmail()

    return (
      <div className="header">
        <h1>
          {lineitem.getTitle()}
        </h1>
        <span>
          Lineitem ID: {lineitem.getId()}
        </span>
        <div className="header-row">
          <StatusSymbol status={lineitem.getState()} qaState={lineitem.getQaState()} />
          <Row type="flex">
            <Col>
              <button className="axiom-button-button-tertiary axiom-button-icon-left" onClick={openSidesheet}>
                <i className="axiom-icon-icon icon-list"/> History
              </button>
            </Col>
            <Col>
              <SearchSelect
                lineItemUUID={lineitem.getLineItemUUID()}
                projectUUID={lineitem.getProjectUUID()}
                value={value}
                options={users}
                handleUserChange={handleUserChange}
                viewState={viewState}
                userEmail={currentUserEmail}
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default Header;